import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    rootBase: {
        borderRadius: '8px',
        boxSizing: 'border-box',
        cursor: props => props.hasClickEvent ? 'pointer' : 'default',
    }
}));